import { render } from "./MaintenanceSchedule.vue?vue&type=template&id=189b1963"
import script from "./MaintenanceSchedule.vue?vue&type=script&lang=js"
export * from "./MaintenanceSchedule.vue?vue&type=script&lang=js"
script.render = render

export default script